module.exports = __webpack_public_path__ + "static/img/6.2077fb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/6.png
// module id = lzaL
// module chunks = 37